





import Vue from 'vue'
import Component from 'vue-class-component'

@Component<SaveCloud>({
  props: {
    color1: {
      type: String,
      default : "#DCDCDC"
    },
    color2: {
      type: String,
      default: '#5481A6'
    }
  }
})

export default class SaveCloud extends Vue {
  /**
   * Props variables
   */
  color1: string | undefined
  color2: string | undefined

  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */


  /**
   * Getters
   */


  /**
   * Methods
   */

}
